module.exports = __webpack_public_path__ + "img/directory.0cd164df.svg";